type row = {
  t: Function,
  updatedBy?: {
    id?: number,
    firstName?: string,
    lastName?: string,
    changeSource?: "USER" | "SIP" | "SYSTEM" | "THIRD_PARTY_APP",
  },
};

export default function updatedBy(props: row) {
  if (!props.updatedBy) return "-";

  if (!props.updatedBy.changeSource) {
    return `${props.updatedBy.firstName} ${props.updatedBy.lastName}`;
  }

  let updatedBy = "";
  switch (props.updatedBy.changeSource) {
    case "USER":
    case null:
      updatedBy = `${props.updatedBy.firstName} ${props.updatedBy.lastName}`;
      break;
    case "SIP":
      updatedBy = props.t("UPDATED_BY_SIP_FILE", {
        id: props.updatedBy?.id,
      });
      break;
    case "SYSTEM":
      updatedBy = props.t("SYSTEM");
      break;
    case "THIRD_PARTY_APP":
      updatedBy = props.t("THIRD_PARTY_INTEGRATION");
      break;
    default:
      updatedBy = "-";
  }

  return updatedBy;
}
